import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Skeleton from 'react-loading-skeleton';
import { AccordionContent, LinkParagraph, SkeletonContainer, SkeletonParagraph, Subtitle } from './styles';
import { GRID_UNIT } from '../../utilities/grid';
import { Margin } from '../../utilities/margin';
import { Accordion } from '../Accordion';
import { Link } from '../Link';
import { Markdown } from '../Markdown';
import { Text } from '../Text';
import 'react-loading-skeleton/dist/skeleton.css';
export var Faqs = function (_a) {
  var faqsLink = _a.faqsLink,
    faqsList = _a.faqsList,
    onFaqQuestionClick = _a.onFaqQuestionClick,
    onFaqRedirectClick = _a.onFaqRedirectClick,
    page = _a.page,
    readMore = _a.readMore,
    title = _a.title,
    subtitle = _a.subtitle;
  return _jsx("div", {
    "data-cy-label": "faqs",
    children: faqsList.length ? _jsxs(_Fragment, {
      children: [title && _jsx(Text, {
        el: "h6",
        styleName: "title6",
        children: title
      }), subtitle && _jsx(Subtitle, {
        el: "p",
        styleName: "bodyRegular",
        variant: "secondary",
        children: subtitle
      }), faqsList.map(function (question, idx) {
        return _jsx(Accordion, {
          title: question.text,
          titleTextStyles: {
            flexBasis: 'auto',
            marginRight: 0
          },
          variant: "list",
          withoutHeaderMargin: true,
          onClick: onFaqQuestionClick ? function () {
            var _a;
            return onFaqQuestionClick({
              page: page,
              question: question.text,
              questionId: (_a = question.id) !== null && _a !== void 0 ? _a : idx
            });
          } : undefined,
          children: typeof question.answer === 'string' ? _jsx(AccordionContent, {
            children: _jsx(Markdown, {
              markdown: question.answer
            })
          }) : question.answer
        }, "".concat(page, "-").concat(idx));
      }), faqsLink && _jsx(LinkParagraph, {
        el: "p",
        styleName: "bodyRegular",
        children: _jsx(Link, {
          href: faqsLink,
          target: "_blank",
          rel: "noopener",
          role: "primary",
          icon: "internal",
          onClick: onFaqRedirectClick ? function () {
            return onFaqRedirectClick({
              page: page
            });
          } : undefined,
          children: readMore
        })
      })]
    }) : _jsxs(SkeletonContainer, {
      children: [_jsx(Skeleton, {
        width: "241",
        height: "32"
      }), _jsx(Margin, {
        top: GRID_UNIT * 3,
        children: _jsxs("div", {
          children: [_jsx(SkeletonParagraph, {
            children: _jsx(Skeleton, {})
          }), _jsx(SkeletonParagraph, {
            children: _jsx(Skeleton, {})
          })]
        })
      })]
    })
  });
};